export type UrlMap = Record<string, string | Record<string, unknown>>;

// NOTE: Oreder matters for NavBar
export const URLS = {
  HOME: '/',
  SERVICES: {
    ROOT: '/services',
    DESIGN_AND_BUILD: '/services/design-and-build',
    DESIGN_AND_RENOVATE: '/services/design-and-renovate',
  },
  PROJECTS: '/projects',
  FLOOR_PLANS: '/floor-plans',
  ABOUT: {
    ROOT: '/about',
    OUR_TEAM: '/about/our-team',
    OUR_SERVICE_AREAS: '/about/our-service-areas',
  },
  REQUEST_CONSULTATION: '/request-consultation',
} as const;

/*
 * Cloudinary Tags
 */
export const GALLERY_TAG = 'gallery_main';
export const GALLERY_MAX_RESULTS = 15;

/*
 * Recursively flattens the `URLS` object into an array.
 * Supports excluding specific keys and transforming each entry.
 */
export function flattenUrls<T>(
  obj: UrlMap = URLS,
  excludedKeys: string[] = [],
  transformer: (key: string, value: string) => T,
): T[] {
  return Object.entries(obj).flatMap(([key, value]) => {
    if (excludedKeys.includes(key.toLowerCase())) {
      return [];
    }

    if (typeof value === 'string') {
      return [transformer(key, value)];
    }

    return flattenUrls(value as UrlMap, excludedKeys, transformer);
  });
}
